import {
  ConversationMetadata,
  GroupConversationMetadata,
  PrivateConversationMetadata,
} from 'models/twilio';

type MetadataKey = keyof (
  ConversationMetadata
  & PrivateConversationMetadata
  & GroupConversationMetadata
);

type ComparatorFn = (prev: unknown, next: unknown) => boolean;
type MetadataComparator = {
  [key in MetadataKey]?: ComparatorFn;
}

const metadataEquality = <T>(comparator: MetadataComparator) => (
  prevMetadata: T, nextMetadata: T,
) => {
  const isEqual = Object.entries(comparator).every(([key, comparer]) => {
    const prevTarget = prevMetadata?.[key];
    const nextTarget = nextMetadata?.[key];
    return comparer(prevTarget, nextTarget);
  });
  return isEqual;
};

export default metadataEquality;
